/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */

import React, { useState, useEffect } from 'react';
import { Card, Table } from "react-bootstrap";
import { sdGetMe, sdGetProjects } from 'services/service-desk/sdService';
import { sdCreateRequest, sdMakeRequests, sdRenderLoadingOrError, sdRequestsCompleted, sdUTCTimestampToFriendlyDateAndTimeAgo } from 'helpers/sdHelper';
import PageHeader from 'components/common/PageHeader';

function ProjectsTable(props) {
  return (
    <Table striped responsive hover>
      <thead>
        <tr>
          <th scope="col">Key</th>
          <th scope="col">Name</th>
          <th scope="col">Mailbox Enabled</th>
          <th scope="col">Mailbox Name</th>
          <th scope="col">Mailbox Last Process</th>
        </tr>
      </thead>
      <tbody>
        {props.projects.map((project) => (
          <tr key={project.id}>
            <td><a href={`/service-desk/admin/project/${project.id}`} target='_blank' rel="noreferrer"><b>{project.key}</b></a></td>
            <td>{project.name}</td>
            <td>{project.mailboxEnabled ? 'Yes' : 'No'}</td>
            <td>{project.mailboxName}</td>
            <td>{project.mailboxLastProcess ? sdUTCTimestampToFriendlyDateAndTimeAgo(project.mailboxLastProcess) : ''}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}

const SDProjects = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [me, setMe] = useState(null);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    let allRequests = [
      sdCreateRequest(() => sdGetProjects(), setProjects),
      sdCreateRequest(() => sdGetMe(), setMe),
    ];

    sdMakeRequests(allRequests, setLoading, setError);
  }, []);

  if (!sdRequestsCompleted(loading, error)) {
    return sdRenderLoadingOrError(loading, error);
  }

  return (
    <>
      <PageHeader
        className='mb-3'
        title="Projects"
      />

      <Card className='p-0 m-0'>
        <Card.Body className='p-1'>
          <ProjectsTable projects={projects}></ProjectsTable>
        </Card.Body>
      </Card>

    </>
  );
};

export default SDProjects;